import { styled } from "@mui/material";

export default styled("div")`

    margin-bottom: 3em;
`;
